// @flow

import adaptFacets from './adapt-facets';
import isFacetOptionsPresentInNavigationData from './style-facet-options-checker/check-facet-options-in-navigation-data';

const sortOrders = [
  {
    compareFn: (prevOrder, nextOrder) => {
      return prevOrder === nextOrder;
    },
    order: 0,
  },
  {
    compareFn: (prevOrder, nextOrder) => {
      return prevOrder === undefined;
    },
    order: 1,
  },
  {
    compareFn: (prevOrder, nextOrder) => {
      return prevOrder > nextOrder;
    },
    order: 1,
  },
];

const byOrder = (previous, next) => {
  const sortOrder = sortOrders.find((sortOrder) =>
    sortOrder.compareFn(previous.order, next.order)
  );
  return sortOrder ? sortOrder.order : -1;
};

const flexFacetsAdapter = (
  data: ProductsWithFlexFacetsResponse,
  hideDepartmentFacet: boolean,
  hidePriceFacet: boolean,
  hideRatingsFacet: boolean,
  isDynamicStyleFacetNameEnabled: boolean,
  webHierarchy: [],
  selectedNodes: []
): { appliedFacets: {}, facetOptions: Array<{}> } => {
  const facets = adaptFacets(
    data.facets ?? [],
    hideDepartmentFacet,
    hidePriceFacet,
    hideRatingsFacet
  );

  const appliedFacets = facets.reduce((applied, { facet, appliedValues }) => {
    applied[facet.name] = appliedValues;

    return applied;
  }, {});

  const facetOptions = facets
    .map<any>(({ facet }) => {
      const facetOption = { ...facet, isActive: 'true' };
      if (isDynamicStyleFacetNameEnabled && facet.name.trim() === 'style') {
        facetOption.dynamicFacetName = isFacetOptionsPresentInNavigationData(
          facet,
          webHierarchy,
          selectedNodes
        );
      }
      return facetOption;
    })
    .sort(byOrder);

  const hasTags = Object.keys(appliedFacets)
    .map((name) => appliedFacets[name])
    .some((applied) => applied.length > 0);

  return {
    appliedFacets,
    facetOptions,
    hasTags,
  };
};

export default flexFacetsAdapter;
